// extracted by mini-css-extract-plugin
export var cardLayout = "_7p-1";
export var paginationContainer = "_7p-0";